// extracted by mini-css-extract-plugin
export default {"ItemDIV":"NewsItems_ItemDIV__EBL+7","ImgDIV":"NewsItems_ImgDIV__BZZDq","TextDIV":"NewsItems_TextDIV__APcOB"};